export default __webpack_public_path__ + "review_profile_enthusiast_badge.1ac07844.svg";